import CustomSkeleton from './CustomSkeleton';

export default CustomSkeleton;
